import { render, staticRenderFns } from "./workflowSettingManageList.vue?vue&type=template&id=48242868&scoped=true"
import script from "./workflowSettingManageList.vue?vue&type=script&lang=js"
export * from "./workflowSettingManageList.vue?vue&type=script&lang=js"
import style0 from "./workflowSettingManageList.vue?vue&type=style&index=0&id=48242868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48242868",
  null
  
)

export default component.exports